var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state.loader)?_c('v-container',[_c('v-overlay',{attrs:{"z-index":_vm.zIndex,"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.colorSet.norbitPrimary,"size":"100"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }